import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ReactNode } from "react";
import { FlipDirection } from "./brandOverview.types";
import { FLIP_HALF_SEC } from "./constants";

type FlipPanelProps = {
  panelKey: string;
  direction: FlipDirection;
  children: ReactNode;
};

export const FlipPanel = ({
  panelKey,
  direction,
  children,
}: FlipPanelProps) => {
  const reduceMotion = useReducedMotion();

  // forward: exit +90, enter from -90 · reverse mirrors it (exit -90, enter +90)
  const enterRotate = direction === "reverse" ? 90 : -90;
  const exitRotate = direction === "reverse" ? -90 : 90;

  return (
    <div style={{ perspective: 1400 }}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={panelKey}
          initial={
            reduceMotion ? { opacity: 0 } : { rotateY: enterRotate, opacity: 0 }
          }
          animate={{
            rotateY: 0,
            opacity: 1,
            transition: {
              duration: reduceMotion ? 0 : FLIP_HALF_SEC,
              ease: "easeInOut",
            },
          }}
          exit={
            reduceMotion
              ? { opacity: 0, transition: { duration: 0 } }
              : {
                  rotateY: exitRotate,
                  opacity: 0,
                  transition: { duration: FLIP_HALF_SEC, ease: "easeInOut" },
                }
          }
          style={{
            transformStyle: "preserve-3d",
            backfaceVisibility: "hidden",
            transformOrigin: "center",
            willChange: "transform, opacity",
          }}
          className="t-flex t-min-h-[500px] t-flex-col t-rounded-xl t-border t-border-solid t-border-neutral-10 t-bg-surface t-bg-entity-panel-gradient t-p-5"
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
